import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {ApiService} from "../../../services/api.service";
import {TemplateService} from "../../../services/template.service";
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {fakeAsync} from "@angular/core/testing";


@Component({
  selector: 'app-saletax-grouped-list-detail',
  templateUrl: './grouped-list-detail.component.html',
  styleUrls: ['./grouped-list-detail.component.scss']
})
export class GroupedSaleTaxListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'tax-list-detail-modal'
  };

  totalSelected = [];
  checkedSelect = [];

  inputText: any;
  list: any = [];
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  totalItems: number;
  selectedValues = [];
  currentPage = 1;
  checked = false;
  url: any;
  date: Date;
  searchParams: any;
  title=""
  loading = false;

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: BsModalService,
              private template: TemplateService) {
  }

  open(selectedRowData) {
    let month = selectedRowData['month']
    let year = selectedRowData['year']

    this.searchParams['month'] = month
    this.searchParams['year'] = year
    this.title = "ภาษีขายประจำเดือน " + month + " ปี " + year

    if (this.currentPage === 1)
      this.pageChanged()
    else
      this.currentPage = 1

    this.modalRef = this.modalService.show(this.modalTemplate, this.config);
  }

  ngOnInit() {
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchE(params);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  searchE(params?) {
    if (this.currentPage === 1) {
      this.apiService.postSearch(this.searchParams).subscribe(
        (res: any) => {
          this.list = res.results;
          this.totalItems = res.count;
        }
      );
    } else {
      this.apiService.postSearch1(this.searchParams, params).subscribe(
        (res: any) => {
          this.list = res.results;
          this.totalItems = res.count;
        }
      );
    }
  }

  Download() {
    const total = this.totalSelected.join(',');
    // const params = new HttpParams().set('list_id', total);
    // this.url = environment.apiURL + '/api/zip_xml/' + '?' + params;

    this.date = new Date();
    const params = new HttpParams().set('list_id', total);
    // this.url = environment.apiURL + '/api/zip_xml/' + '?' + params;
    this.loading = true;
    this.apiService.getZip(params).subscribe(
      (obj) => {
        let filename = 'documents' + moment().format('YYYY-MM-DD') + '.zip';
        this.apiService.createDownloadFile(obj, filename);
        this.pageChanged();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    )
  }

  selectAll() {
    this.checkedSelect[this.currentPage] = !this.checkedSelect[this.currentPage];
    if (this.checkedSelect[this.currentPage]) {
      _.forEach(this.list, (value) => {
        this.selectedValues[value.id] = true;
        this.totalSelected.push(value.id);
      });
      this.totalSelected = _.uniq(this.totalSelected);
    } else {
      _.forEach(this.list, (value) => {
        this.selectedValues[value.id] = false;
        this.totalSelected = _.filter(this.totalSelected, (num) => {
          return num !== value.id;
        });
      });
    }
  }

  selectChild(id) {
    if (this.selectedValues[id]) {
      this.totalSelected.push(id);
    } else {
      this.totalSelected = _.filter(this.totalSelected, (value) => {
        return value !== id;
      });
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list-detail/grouped-list-detail.component.ts